/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Cancel_TitleInputs */

const da_terms_cancel_title = /** @type {(inputs: Terms_Cancel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opsigelse`)
};

/** @type {(inputs: Terms_Cancel_TitleInputs) => LocalizedString} */
const en_terms_cancel_title = da_terms_cancel_title;

/**

* @param {Terms_Cancel_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const terms_cancel_title = /** @type {((inputs?: Terms_Cancel_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Cancel_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_cancel_title(inputs)
	return /** @type {LocalizedString} */ ("Opsigelse")
});